import { MediaEmbedSliceData } from '@adapters/prismic/types/slices';

import YouTubeEmbed from './YouTubeEmbed';
import InstagramEmbed from './InstagramEmbed';
import VimeoEmbed from './VimeoEmbed';

import styles from './MediaEmbed.module.scss';

const MediaEmbed = ({
  id,
  embed: { provider_name, height, width, html },
}: MediaEmbedSliceData) => {
  const getMediaEmbed = (type: string) => {
    switch (type) {
      case 'Instagram':
        return <InstagramEmbed html={html} />;
      case 'YouTube':
        return (
          <YouTubeEmbed
            html={html}
            dimensions={{ height, width }}
            showSubscribe
          />
        );
      case 'Vimeo':
        return <VimeoEmbed html={html} dimensions={{ height, width }} />;
      default:
        return <></>;
    }
  };
  return (
    <div
      data-testid="data-media-embed"
      id={id}
      className={styles.mediaEmbedContainer}
    >
      {getMediaEmbed(provider_name)}
    </div>
  );
};

export default MediaEmbed;
